import Styled from 'styled-components';

import { SVGIcon } from '../../Icon';
import { ISVGIconProps } from '../../Icon/SVGIcon';

export interface ISVGContainerProps {
  iconHeight?: string;
  iconWidth?: string;
}

export const SvgContainer = Styled(SVGIcon)<ISVGContainerProps & ISVGIconProps>`
  display: inline-flex;
  align-content: center;
  align-items: center;
  margin-left: 0.25em;

  svg {
    height: ${props => props.iconHeight};
    pointer-events: none;
    transition: color 100ms ease-out;
    width: ${props => props.iconWidth};
  }
`;

SvgContainer.defaultProps = {
  iconHeight: '1.375em',
  iconWidth: '1.375em'
};
